export default "__VITE_ASSET__da852545__"